import { render, staticRenderFns } from "./GooglePlay.vue?vue&type=template&id=13d4a540"
import script from "./GooglePlay.vue?vue&type=script&lang=js"
export * from "./GooglePlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports